'use client';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '../Button/Button';
import { Row } from '../server/layout/Row/index';
import { I } from '../system/icons';
import { useCursorHistory } from './useCursorHistory';
export function PagedTable({ page, currentCursor, onPageChange, children, historyKey, renderEmpty, }) {
    const history = useCursorHistory(historyKey);
    const onOlder = () => {
        if (!page.nextCursor)
            return;
        history.push(currentCursor);
        onPageChange(page.nextCursor);
    };
    const onNewer = () => {
        const prev = history.pop();
        onPageChange(prev);
    };
    const onNewest = () => {
        history.reset();
        onPageChange(null);
    };
    if (page.items.length === 0 && !history.canGoBack && currentCursor === null) {
        return _jsx(_Fragment, { children: renderEmpty?.() ?? null });
    }
    const showNewer = history.canGoBack;
    const showNewest = currentCursor !== null;
    const showOlder = page.nextCursor !== null;
    return (_jsxs(_Fragment, { children: [children(page.items), _jsxs(Row, { justify: "space-between", align: "center", gap: "md", style: { paddingTop: 'var(--space-lg)' }, children: [_jsx("div", { children: showNewest ? (_jsx(Button, { variant: "ghost", size: "sm", onClick: onNewest, children: "Newest" })) : null }), _jsxs(Row, { gap: "sm", children: [showNewer ? (_jsx(Button, { variant: "secondary", size: "sm", icon: I.back, onClick: onNewer, children: "Newer" })) : null, showOlder ? (_jsx(Button, { variant: "secondary", size: "sm", iconRight: I.arrow, onClick: onOlder, children: "Older" })) : null] })] })] }));
}
//# sourceMappingURL=PagedTable.js.map